<template>
	<div class="home">
		<full-page ref="fullpage" :options="options" id="fullpage" v-if="!$mobile">
			
			<div class="section">
				<Video />
			</div>

			<div class="section">
				<Water />
			</div>

			<div class="section">
				<Masters />
			</div>
			
		</full-page>

		<div v-else>

			<div class="section">
				<VideoMobile />
			</div>

			<div class="section">
				<Water />
			</div>

			<div class="section">
				<Masters />
			</div>

		</div>


	</div>
</template>

<script>
import Video from '@/components/Video'
import VideoMobile from '@/components/VideoMobile'
import Water from '@/components/Water'
import Masters from '@/components/Masters'
import Events from '@/events'

export default {
	name: 'home',
	components: {
		Video,
		VideoMobile,
		Water,
		Masters,
	},
	data() {
		return {
			options: {
				licenseKey: '6E8F5101-0A6A4218-AEC61F0C-EF812275',
				onLeave: this.onLeave,
			}
		}
	},
	head: {
		meta() {
			return [
				{ property: 'og:title', content: 'Карта Вкусов' },
				{ property: 'og:description', content: 'Делайте гастрономические открытия вместе с Aqua Minerale с соком!' },
				{ property: 'og:image', content: `https://aquaminerale.eda.ru/share.jpg` },
				{ property: 'og:site_name', content: 'Карта Вкусов' },
			]
		},
	},
	methods: {
		onLeave(from, to) {
			Events.$emit('change-slide', to.index)
		}
	},
}
</script>


<style lang="less" scoped>
@import "../assets/app.less";


@media only screen and (max-width: 1000px) {

.section {
	width: 100vw;
	min-height: 100vh;
	height: fit-content;
	position: relative;
}

}




</style>